/* eslint-disable */
import Vue from 'vue'
import axios from 'axios'
import { requestError } from '@/services/http'
import store from '@/store'

const config = {
  baseURL: process.env.VUE_APP_BASE_URL || 'http://localhost:3000'
}

const httpAuth = axios.create(config)

httpAuth.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, Accept, Content-Type, Authorization, Access-Control-Allow-Origin'

function trataToken (acesso) {
  let auth = window.localStorage.getItem('auth')
  auth = auth ? JSON.parse(auth) : {}

  const token = store ? store.getters['authData/token'](acesso) : auth.token
  httpAuth.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
/* eslint-disable */
Plugin.install = function (Vue, options) {
  Vue.axios = httpAuth
  window.axios = httpAuth
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return httpAuth
      }
    },
    $axios: {
      get () {
        return httpAuth
      }
    }
  })
}

Vue.use(Plugin)

export default {
  httpAuth,
  async get (url, acesso = {}, filtro = {}) {
    trataToken(acesso)
    return requestError(httpAuth.get(url, { params: filtro }))
  },
  async post (url, data, acesso = {}) {
    trataToken(acesso)
    return requestError(httpAuth.post(url, data))
  },
  async put (url, data, acesso = {}) {
    trataToken(acesso)
    return requestError(httpAuth.put(url, data))
  },
  async delete (url, acesso = {}) {
    trataToken(acesso)
    return requestError(httpAuth.delete(url))
  }
}
